module.exports = __webpack_public_path__ + "static/media/beach-5.2e3e9168.jpg";